import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import TickerItem from "../TickerItem/TickerItem";


const TickerGroup = (props) => {
  // const [data, setData] = useState([]);
  // const updateTicker = () => {
  //   setData(props.items);
  // };
  const data = props.items;

  // useEffect(() => {
  //   updateTicker();
  // }, [props.items]);
  return (
    <>
      {data?.length > 0 ? (
        data.map((val) => (
          <TickerItem
            key={val.currency}
            flag={val.flag}
            pair={val.currency.replace(" ", "/")}
            rate={val.rate}
          />
        ))
      ) : (
        <></>
      )}
    </>
  );
};
TickerGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      currency: PropTypes.string.isRequired,
      flag: PropTypes.string.isRequired,
      rate: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default TickerGroup;

